import React, { useEffect, useState } from 'react';
import SubMainComponent from './subMainComponent';
import './mainStyles.css';
import AlertDialog from './errorDialog';
import { Button, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import * as registerActions from '../core/Store/Actions/RegisterActions';
import Loader from './loader';
import { useNavigate } from 'react-router-dom';

const MainComponent = (props) => {
    const { Component } = props;
    const navigate = useNavigate();
    const apiFailed = useSelector(state => state.registerReducer.apiFailed);
    const loading = useSelector(state => state.patientReducer.loading);
    const [openModal, setOpen] = useState(false);
    const [msg, setMsg] = useState('');
    const [errorType, setErrorType] = useState(false);
    const dispatch = useDispatch();
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        dispatch(registerActions.onErrorOccured({}));
        setErrorType(false);
        if(!errorType){
            navigate('/');
        }
    };
    useEffect(() => {
        if (typeof apiFailed === 'object' && apiFailed !== null && Object.keys(apiFailed).length > 0) {
            setMsg(apiFailed.exception_message || apiFailed.status_message || apiFailed.message || 'Internal server error');
            handleClickOpen();
        } else if (apiFailed && typeof apiFailed == 'string' && String(apiFailed).length > 0) {
            setMsg(apiFailed || 'Something went wrong');
            setErrorType(true);
            handleClickOpen();
        }
    }, [apiFailed]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [Component]);
    const erroDialog = () => (
        <Dialog
            open={openModal}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">Error</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {/* {`There is some problem with the request. Please call 1.844.900.2567 for further assistance`} */}
                    {`${msg}`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {errorType ?
                    <Button onClick={handleClose} color="primary">
                        Ok
                    </Button>
                    :
                    <Button onClick={handleClose} color="primary">
                        Go To Login
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );
    return (
        <div className="mainDiv">
            <div className="subGrid">
                <div style={{ background: "black", overflowY: 'hidden', width: '100%' }} >
                    <SubMainComponent />
                </div>
                {erroDialog()}
                <div style={{ background: "white", overflowY: 'scroll', height: '100vh', width: '100%' }}>
                    <Component />
                </div>
            </div>
        </div>
    )
}

export default MainComponent
